import { render, staticRenderFns } from "./workOrderDescContent.vue?vue&type=template&id=61eb245a&scoped=true"
import script from "./workOrderDescContent.vue?vue&type=script&lang=js"
export * from "./workOrderDescContent.vue?vue&type=script&lang=js"
import style0 from "./workOrderDescContent.vue?vue&type=style&index=0&id=61eb245a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61eb245a",
  null
  
)

export default component.exports